import { getScrollableAncestor } from '../../../helpers/dom';

/*
 * Only ever moves the option list's own scrollTop. `scrollIntoView` would walk every scrollable
 * ancestor and scroll the page along with it, which is exactly what keyboard users complained about.
 */
export const keepOptionVisible = (node: HTMLElement) => {
  const list = getScrollableAncestor(node);
  if (!list) return;

  const listBox = list.getBoundingClientRect();
  const optionBox = node.getBoundingClientRect();

  if (optionBox.top < listBox.top) {
    list.scrollTop -= listBox.top - optionBox.top;
    return;
  }

  if (optionBox.bottom > listBox.bottom) {
    list.scrollTop += optionBox.bottom - listBox.bottom;
  }
};
